module.exports = __webpack_public_path__ + "static/media/play.7bf3c1c7.svg";